import env from '../common/env.js';
import mweixin from '../report/report_base.js';
import * as base from '../base/mbase.js';
import * as str from '../base/string.js';
import * as localstorage from '../base/localstorage.js';
import wxBridge from '../jsbridge/jsbridge_login_queue.js';
import checkErr from './11332_check_error.js';
import calExpID from './11332_cal_expid.js';
import * as util from '../common/util';
import Dom from '../base/mdom.js';
let exportData;
if(!env.isCSR) {
    var getQueryStr  = base.getQueryStr;
    var getKeyValue  = localstorage.getKeyValue;
    var top         = Dom.window;
    /*
    * Example:
        var mweixin = require('report/report_base.js').default;
        mweixin.batchReport = require('report/11332_batch.js').default;
        mwexin.batchReport([{
                iSceneId: 24,
                UIArea: 2402,
                iPositionId: 3,
                OpType: 1,
                ActionID:40
            },{
                iSceneId: 24,
                UIArea: 2403,
                iPositionId: 1,
                OpType: 2,
                ActionID:5
        }]);
    */
    (function (_aoExport, win, doc) {
        "use strict";
        if( win.WXGAME?.Report11332?.reportBatch ) {
            exportData = win.WXGAME.Report11332.reportBatch.bind(win.WXGAME.Report11332)
            return
          }        

        //上报类型中的device必须是字符串，
        //iphone,android-lite-,android,symbian60v3,symbian60v5,
        //wp7,webwx,blackberry-,wp8,s40asha v5,s40asha,BlackBerry10-,其他字符串
        var _reportObj = _aoExport.reportObj;

        function extendExternInfo(obj) {
            var rpt_ssid_str = getQueryStr('rpt_ssid_str') || '';
            var from_id = getQueryStr('from_id');
            var currentPkgid = getQueryStr('wechat_pkgid') || '';
            var fromPkgid = getQueryStr('from_wechat_pkgid') || '';
            var sProt = getQueryStr('s_prot');
            var sUia = getQueryStr('s_uia');
            var sPid = getQueryStr('s_pid')
            var sCid = getQueryStr('s_cid')
            var sCtype = getQueryStr('s_ctype');
            var shareId = getQueryStr('share_id');
            var originShareId = getQueryStr("origin_share_id");
            var externinfo = obj.sExternInfo;
            var globalExternInfo = {}
            if (rpt_ssid_str) {
              globalExternInfo.rpt_ssid_str = rpt_ssid_str;
            }
            if (from_id && /^\d+$/.test(from_id) ) {
                globalExternInfo.from_id = Number(from_id);
            }

            globalExternInfo.pkgid = currentPkgid;
            globalExternInfo.from_pkgid = fromPkgid;
            // 透传其他协议信息
            if( sProt && /^\d+$/.test(sProt)) {
                globalExternInfo.s_prot = Number(sProt);
            }
            if( sUia && /^\d+$/.test(sUia)) {
                globalExternInfo.s_uia = Number(sUia);
            }
            if( sPid && /^\d+$/.test(sPid)) {
                globalExternInfo.s_pid = Number(sPid);
            }
            if( sCid ) {
                globalExternInfo.s_cid = sCid;
            }
            if( sCtype ) {
                globalExternInfo.s_ctype = sCtype;
            }

            // 上报分享来源
            if( shareId ) {
                globalExternInfo.share_id = shareId
            }
            if( originShareId ) {
                globalExternInfo.origin_share_id = originShareId
            }

            try {
                if (Object.keys(globalExternInfo).length === 0) return obj;

                if (!externinfo) {
                    externinfo = JSON.stringify(globalExternInfo);
                } else {
                    if (typeof externinfo === 'string') {

                      var externinfo_obj = JSON.parse(decodeURIComponent(externinfo));
                        externinfo_obj = base.extend(globalExternInfo, externinfo_obj);
                        externinfo = JSON.stringify(externinfo_obj);

                    } else if (typeof externinfo === 'object') {

                        externinfo = JSON.stringify(base.extend(globalExternInfo, externinfo));

                    }
                }

                obj.sExternInfo = externinfo;

                return obj;
            } catch (e) {
                return obj;
            }
        }

        //11332 平台类上报
        function batch11332(list, _slogin, cbk) {
            var xhr = new XMLHttpRequest(),
                _report = [];
            xhr.onreadystatechange = function () {};
            for (var i = 0, il = list.length; i < il; i++) {
                var _o = list[i],
                    _sUrl = '';

                _o = extendExternInfo(_o);

                /**
                 * 这两个值改为由后台获取。现在前端不传值了。
                 */
                // _sUrl += "Device=" + (_o.sDevice || (_reportObj.device == 'iphone' ? 1 : 2) || "0");
                // _sUrl += "&ClientVersion=" + (_o.sClientVersion || _reportObj.clientversion || '0');


                _sUrl += "&ActID="              + (_o.iActID 
                                                    || _reportObj.actid 
                                                    || 0);

                _sUrl += "&LogType="            + (_o.iLogType 
                                                    || _reportObj.iLogType 
                                                    || getQueryStr('abt',null,top) 
                                                    || 0);

                _sUrl += "&SceneID="            + (_o.iSceneId  || 0);
                _sUrl += "&GameID="             + (_o.sGameId   || "");

                let ssid = _o.iSourceSceneId || getQueryStr('ssid',null,top) || 0;
                let sourceid = _o.iSourceId || getQueryStr('source_id',null,top) || 0;
                if( sourceid ) { // 优先取sourceid
                    // 对sourceid做个格式校验，防止类型不对导致整条数据无效
                    if( /^\d+$/.test(sourceid) ) {
                        _sUrl += "&SourceID=" + sourceid;
                    }
                }else if( ssid ) { // 无sourceid，再取ssid, 对旧数据做兼容逻辑
                    // 对ssid做个格式校验，防止类型不对导致整条数据无效
                    if( /^\d+$/.test(ssid) ) { 
                        _sUrl += "&SourceID=" + ssid;
                    }
                }
                // ssid 取 0 ~ 100 之间的
                if( ssid >= 0 && ssid <= 100) {
                    _sUrl += "&ssid=" + ssid;
                }

                let time = _o.iTime;
                // 对time做一个数字类型保护
                if( time ) {
                    time = Number(time)
                    if( time !== time ) { // 如果是NaN的话，强制设置为0
                        time = 0
                    }else { // 强制做一下取整，避免小数
                        time = Math.floor(time)
                    }
                }

                _sUrl += "&UIArea="             + (_o.iUIArea       || 0);
                _sUrl += "&PositionID="         + (_o.iPositionId   || 0);
                _sUrl += "&ActionID="           + (_o.iActionId     || 0);
                _sUrl += "&ActionStatus="       + (_o.sActionStatus || 0);
                _sUrl += "&GiftID="             + (_o.iGiftBagId    || 0);
                _sUrl += "&GiftType="           + (_o.iGiftBagType  || 0);
                _sUrl += "&ChatroomName="       + (_o.iChatroomName  || "");
                _sUrl += "&NoticeID="           + (_o.iNoticeId  || getQueryStr('noticeid',null,top) || 0);

                _sUrl += "&ConnectType="        + (_o.sConnectType 
                                                    || _reportObj.networktype 
                                                    || "");

                _sUrl += "&ISP="                + (_o.sServiceProvider  || '');
                _sUrl += "&DeviceBrand="        + (_o.sDeviceBrand      || '');
                _sUrl += "&DeviceModel="        + (_o.sDeviceModel      || '');
                _sUrl += "&OpType="             + (_o.iOpType           || 0);

                var expObj = calExpID(_o);
                _sUrl += '&ExpID='              + (_o.iExpID            || expObj.exp_id    || 0);
                _sUrl += '&ReasonID='           + (_o.iReasonID         || expObj.reason_id || 0);


                _sUrl += "&allpath="            + (getQueryStr('rpt_allpath') || "");
                
                _sUrl += "&ExternInfo="         + str.exencodeURIComponent((_o.sExternInfo 
                                                    || _reportObj.sExternInfo 
                                                    || "")) ;

                _sUrl += '&getType='            + (env.isWepkg() ? 1 : 2);
                _sUrl += '&URL='                + encodeURIComponent(location.href.split("#")[0]
                                                .replace(/&(uin|pass_ticket|key)=[^&]+/g, '')
                                                .replace(/\?(uin|pass_ticket|key)=[^&]+/g, '?'));
                
                _sUrl += '&errType='            + checkErr(_o);
                // var errType = checkErr(_o);
                
                // 新增字段 ContentType Time VideoID ExpID ReasonID
                // tapd: http://tapd.oa.com/10079491/prong/stories/view/1010079491064596219
                if(_o.iContentType)  _sUrl += '&ContentType='    + (_o.iContentType  || 0);
                if(time)         _sUrl += '&Time='           + (time         || 0);
                if(_o.sVideoID)      _sUrl += '&VideoID='        + (_o.sVideoID      || "");
                // if(_o.iExpID)        _sUrl += '&ExpID='          + (_o.iExpID        || calExpID(_o) || 0);
                if(_o.iReasonID)     _sUrl += '&ReasonID='       + (_o.iReasonID     || 0);
                // 用户行为发生时的时间戳
                _sUrl += '&client_timestamp=' + Date.now();
                
                if(window.__KULP_BUILD_VERSION__) {
                    _sUrl += '&BuildVersion=' + (window.__KULP_BUILD_VERSION__ || "");
                }
                _report.push(_sUrl);
            }
            var method = _report.length > 1 ? 'POST' : 'GET';
            var tparam = {};
            _slogin = _slogin || '';
            
            var qryStr;
            if(env.isMSDK) {
                qryStr = '//game.weixin.qq.com/cgi-bin/groupwap/reportstat?';

                qryStr += util.getInGameLoginByType();

                for(var i = 0, il = _report.length; i < il; i++) {
                    var xhr2 = new XMLHttpRequest();
                    xhr2.open('GET', qryStr + _report[i], true);
                    xhr2.send(null);
                }
            }else {
                wxBridge.getUinKey(function(login){
                    // 兼容去登录态逻辑
                    var loginInfo = {
                        uin         : login.uin,
                        key         : login.key,
                        pass_ticket : login.pass_ticket
                    };
                    var qryStr = '/cgi-bin/comm/cltstat?' 
                                + (_slogin || '') 
                                + ( tparam == {}      ? '' : '&' + str.mapToStr(loginInfo))
                                + (_report.length > 1 ? '' : '&' + _report[0])
                                + "&QB&";
    
                    xhr.open(method, qryStr, true);
                    let gameSessionId = env.getGameSessionId();
                    if( gameSessionId ) {
                        xhr.setRequestHeader('x-wxgame-session', gameSessionId);
                    }
                    
                    if (_report.length > 1) {
                        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                    }
                    xhr.send(_report.length > 1 ? 'BatchData=' + encodeURIComponent(JSON.stringify(_report)) : null);
                });
            }
            
        }
        exportData = batch11332;
    })(mweixin, window, document);
}

export default exportData;